module.exports = __webpack_public_path__ + "assets/img/sign_in_repair.b2e72c8a.png";